/* global showSuccessToast */
/* global showDangerToast */
/* global showInfoToast */
/* global showWarningToast */

import React, { useState, useContext, useEffect, use, useRef } from 'react';
import { AuthContext, AuthProvider } from './context/AuthContext';
import { SearchContext } from './layout/SearchContext';
import {
    getUser,
    getTargetItems,
    getTargetByID,
    getCarriers,
    getTargetTypes,
    getList,
    addContactHistory,
    getContactHistory,
    getUsers,
    saveQualityFeedback,
    getQualityOpen,
    getQualityClose,
    getQualityQuestions,
    getQualityAnswers,
    addQualityAnswer
} from '../api/api';
import globals from '../config/globals.json'
import FooterBar from './layout/FooterBar';
import Calendar from './tools/Calendar';
import FooterButton from './tools/FooterButton';
import groupTargetItemsByContact from '../utils/groupTargetItemsByContact';

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
}

const Account = (props) => {
    const companyID = props.userDetails?.Company?.[0]?.dataID || null;
    const { user } = useContext(AuthContext);
    const [userDetails, setUserDetails] = useState(null);
    const [targetItems, setTargetItems] = useState([]);
    const [targetTypes, setTargetTypes] = useState([]);
    const [carriers, setCarriers] = useState([]);
    const [selectedContact, setSelectedContact] = useState(null);
    const [selectedTargetItem, setSelectedTargetItem] = useState(null);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);

    const [formDate, setFormDate] = useState(() => new Date().toISOString().slice(0, 10));
    const [formNotes, setFormNotes] = useState("");
    const [formRatio, setFormRatio] = useState("");

    const [qualityEvaluation, setQualityEvaluation] = useState("");
    const [qualityFeedback, setQualityFeedback] = useState("");
    const [qualityQuestions, setQualityQuestions] = useState("");
    const [qualityClose, setQualityClose] = useState("");
    const [qualityOpen, setQualityOpen] = useState("");

    const [qualityQuestionRatings, setQualityQuestionRatings] = useState([]);
    const [qualityQuestionAnswers, setQualityQuestionAnswers] = useState([]);

    const [qualityAnswers, setQualityAnswers] = useState({});

    const [contactHistory, setContactHistory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadProgress, setLoadProgress] = useState(null);
    const [loadError, setLoadError] = useState("");
    const fetchRequestId = useRef(0);

    const [sortKey, setSortKey] = useState("lastName");
    const [sortOrder, setSortOrder] = useState("date-desc");

    const [carrierFilter, setCarrierFilter] = useState("");
    const [typeFilter, setTypeFilter] = useState("");
    const [userFilter, setUserFilter] = useState("");
    const [dateStart, setDateStart] = useState("");
    const [dateEnd, setDateEnd] = useState("");
    const { searchTerm, clearSearch } = useContext(SearchContext);
    const [showOnlyFilteredData, setShowOnlyFilteredData] = useState(false);

    const [users, setUsers] = useState([]);
    let totalItems = 0;

    const [marketingMessage, setMarketingMessage] = useState("Esempio di messaggio marketing personalizzato per il cliente. Puoi utilizzare questo spazio per promuovere offerte speciali, nuovi prodotti o servizi, o semplicemente per ringraziare il cliente per la sua fedeltà.");

    const matchesSelectedFilters = (target) => {
        const item = target.node;
        const contact = item.Contact[0];
        const targetName = item.Target[0].name;

        if (carrierFilter && !targetName.startsWith(carrierFilter)) return false;
        if (userFilter && !item.User[0].username.startsWith(userFilter)) return false;
        if (typeFilter && !item.Target[0].TargetType[0].name.startsWith(typeFilter)) return false;

        const date = item.date ? item.date.slice(0, 10) : "";
        if (dateStart && date < dateStart) return false;
        if (dateEnd && date > dateEnd) return false;

        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            const fullName = `${contact.lastName} ${contact.firstName}`.toLowerCase();
            if (!fullName.includes(term) && !targetName.toLowerCase().includes(term)) return false;
        }

        return true;
    };

    const loadContactHistory = async (selectedContact) => {
        const response = await getContactHistory(selectedContact.id);
        setContactHistory(response.data.data.getContactHistoryListing.edges);
    };

    const loadUserDetails = async (user) => {
        const response = await getUser(user);
        setUserDetails(response.data.data.getUserListing.edges[0].node);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);

        const plainData = {
            ...Object.fromEntries(formData.entries()),
        };
        await addContactHistory(plainData).then(response => {
            showSuccessToast("Ricontatto aggiunto con successo!");
            setFormNotes("");
            setFormRatio("");
            loadContactHistory(selectedContact);
        });
    }

    const handleOpenQualityModal = (target) => {
        setQualityQuestionAnswers([]);
        setQualityQuestionRatings([]);
        setQualityFeedback("");
        setSelectedTargetItem(target);
        setQualityEvaluation(target.evaluation ? target.evaluation : 0);
        setQualityFeedback(target.feedback ? target.feedback : "");
        getQualityQuestions(companyID, target.Target[0].id).then(response => {
            setQualityQuestions(response.data.data.getQualityQuestionListing.edges);
        });
        getQualityOpen(companyID, target.Target[0].id).then(response => {
            setQualityOpen(response.data.data.getQualityOpenListing.edges);
        });
        getQualityClose(companyID, target.Target[0].id).then(response => {
            setQualityClose(response.data.data.getQualityCloseListing.edges);
        });
        getQualityAnswers(companyID, target.id).then(response => {
            const answers = [];
            response.data.data.getQualityAnswerListing.edges.forEach(edge => {
                answers.push(edge.node);
            });
            setQualityAnswers(answers);
        });
    }

    const handleSubmitQuality = async (e) => {
        e.preventDefault();
        if (window.confirm("Vuoi procedere con il salvataggio definitivo della quality call?")) {
            const formData = new FormData(e.target);

            for (let index = 0; index < qualityQuestions.length; index++) {
                const question = qualityQuestions[index];
                const plainData = {
                    QualityQuestion: question.node.id,
                    answer: qualityQuestionAnswers[index],
                    rating: qualityQuestionRatings[index],
                };
                const qualityResponse = await addQualityAnswer(plainData, companyID, selectedTargetItem.id);
                if (!qualityResponse?.data?.data?.createQualityAnswer?.output?.id) {
                    console.error("Errore: risposta non valida durante l'aggiunta della quality answer", qualityResponse);
                    showDangerToast("Errore nell'aggiunta della quality answer: ");
                    return;
                }
            }
            showSuccessToast("Quality call aggiunta con successo!");

            const plainData = {
                feedback: qualityFeedback,
                evaluation: qualityEvaluation
            };

            await saveQualityFeedback(selectedTargetItem.id, plainData).then(response => {
                showSuccessToast("Feedback salvato correttamente!");
                getTargetByID(selectedTargetItem.id).then(response => {
                    const updatedTarget = response.data.data.getTargetItemListing.edges[0].node;
                    setSelectedTargetItem(updatedTarget);
                    setQualityEvaluation(updatedTarget.evaluation);
                    document.querySelector(`#evaluation-${updatedTarget.id}`).value = updatedTarget.evaluation;
                });
            });

            setQualityQuestionAnswers([]);
            setQualityQuestionRatings([]);
            setQualityFeedback("");

            // Close modal
            const modal = document.getElementById('modal-quality-call');
            window.$(modal).modal('hide');
        }
    }

    const loadUsers = async () => {
        try {
            const response = await getUsers(companyID);
            if (response.data.data.getUserListing.edges.length > 0) {
                setUsers(response.data.data.getUserListing.edges);
            }
        } catch (error) {
            console.error("Error loading users:", error);
        }
    };

    const loadAllTargetItems = async () => {
        const requestId = ++fetchRequestId.current;
        const pageSize = 500;
        setLoading(true);
        setLoadProgress(null);
        setLoadError("");

        try {
            const firstResponse = await getTargetItems(companyID, pageSize, 0, "");
            const firstPageItems = firstResponse.data?.data?.getTargetItemListing?.edges;
            if (!Array.isArray(firstPageItems)) {
                throw new Error("Risposta non valida durante il caricamento della timeline");
            }
            if (requestId !== fetchRequestId.current) return [];

            let allItems = firstPageItems;
            setTargetItems(groupTargetItemsByContact(firstPageItems));
            setLoading(false);

            let page = 1;
            let hasMore = firstPageItems.length === pageSize;
            const totalCount = firstResponse.data?.data?.getTargetItemListing?.totalCount || 0;
            const updateProgress = (loaded) => setLoadProgress(
                totalCount ? Math.min(99, Math.round((loaded / totalCount) * 100)) : 0
            );
            if (hasMore) updateProgress(allItems.length);

            while (hasMore) {
                const response = await getTargetItems(companyID, pageSize, page * pageSize, "");
                const pageItems = response.data?.data?.getTargetItemListing?.edges;
                if (!Array.isArray(pageItems)) {
                    throw new Error("Risposta non valida durante il caricamento della timeline");
                }
                if (requestId !== fetchRequestId.current) return allItems;

                allItems = allItems.concat(pageItems);
                updateProgress(allItems.length);
                setTargetItems(currentItems => groupTargetItemsByContact(pageItems, currentItems));
                page++;
                hasMore = pageItems.length === pageSize;
            }

            return allItems;
        } catch (error) {
            console.error("Errore nel caricamento della timeline:", error);
            if (requestId === fetchRequestId.current) {
                setLoadError("Non è stato possibile caricare tutti gli elementi. Riprova.");
            }
            return [];
        } finally {
            if (requestId === fetchRequestId.current) {
                setLoading(false);
                setLoadProgress(null);
            }
        }
    };

    const fetchCarriers = async () => {
        const response = await getCarriers(companyID);
        if (response) {
            setCarriers(response.data.data.getCarrierListing.edges);
        }
    }

    const fetchTargetTypes = async () => {
        const response = await getTargetTypes(companyID);
        if (response) {
            setTargetTypes(response.data.data.getTargetTypeListing.edges);
        }
    }

    const generatePDF = async () => {
        try {
            const response = await getList();
            if (response.status === 200) {
                const blob = new Blob([response.data], { type: "application/pdf" });
                const url = window.URL.createObjectURL(blob);
                window.open(url, "_blank"); // Apre il PDF in una nuova scheda
            } else {
                console.error("Error generating PDF:", response);
            }
        } catch (error) {
            console.error("Error generating PDF:", error);
        }
    };

    useEffect(() => {
        loadUserDetails(user);
        loadUsers();
        fetchCarriers();
        fetchTargetTypes();
    }, [companyID]);

    useEffect(() => {
        if (selectedContact) {
            loadContactHistory(selectedContact);
        }
    }, [selectedContact]);

    useEffect(() => {
        if (userDetails) {
            loadAllTargetItems();
        }
        return () => {
            fetchRequestId.current += 1;
        };
    }, [userDetails]);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-4 col-md-5">
                    <div className="card">
                        <div className="card-body">
                            <div className="text-center">
                                <img className="rounded-circle" width={150} src={userDetails && userDetails.avatar ? "https://x1.dixxip.com/dixcore/public/var/assets" + userDetails.avatar.fullpath : null} alt="" />
                                <h4 className="card-title mt-10">{user.toUpperCase()}</h4>
                                <p className="card-subtitle">{userDetails && userDetails.role >= 0 ? globals.USER_ROLE[userDetails.role].toUpperCase() : ""}</p>
                                <div className="row text-center justify-content-md-center">
                                    {/* <div className="col-4"><a href="javascript:void(0)" className="link"><i className="ik ik-user" /> <font className="font-medium">254</font></a></div> */}
                                    {/* <div className="col-4"><a href="javascript:void(0)" className="link"><i className="ik ik-image" /> <font className="font-medium">54</font></a></div> */}
                                </div>
                            </div>
                        </div>
                        <hr className="mb-0" />
                        <div className="card-body">
                            {userDetails && userDetails.Person && userDetails.Person[0].email ? (
                                <>
                                    <small className="text-muted d-block">Email address </small>
                                    <h6>{userDetails.Person[0].email}</h6>
                                </>
                            ) : null}
                            {userDetails && userDetails.Person && userDetails.Person[0].phone1 ? (
                                <>
                                    <small className="text-muted d-block pt-10">Phone</small>
                                    <h6>{userDetails.Person[0].phone1}</h6>
                                </>
                            ) : null}
                            {userDetails && userDetails.Person && userDetails.Person[0].address ? (
                                <>
                                    <small className="text-muted d-block pt-10">Address</small>
                                    <h6>{userDetails.Person[0].address}</h6>
                                    <div className="map-box">
                                        {userDetails && userDetails.Person && userDetails.Person[0].address ? (
                                            <iframe
                                                src={`https://www.google.com/maps?q=${encodeURIComponent(userDetails.Person[0].address)}&output=embed`}
                                                width="100%"
                                                height={300}
                                                frameBorder={0}
                                                style={{ border: 0 }}
                                                allowFullScreen
                                                title="User Address Map"
                                            />
                                        ) : null}
                                    </div>
                                </>
                            ) : null}
                        </div>
                    </div>
                </div>
                <div className="col-lg-8 col-md-7">
                    <div className="card">
                        <ul className="nav nav-pills custom-pills" id="pills-tab" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active" id="pills-timeline-tab" data-toggle="pill" href="#current-month" role="tab" aria-controls="pills-timeline" aria-selected="true">Timeline</a>
                            </li>
                            {/* <li className="nav-item">
                                <a className="nav-link" id="pills-profile-tab" data-toggle="pill" href="#last-month" role="tab" aria-controls="pills-profile" aria-selected="false">Profile</a>
                            </li> */}
                            {/* <li className="nav-item">
                                <a className="nav-link" id="pills-setting-tab" data-toggle="pill" href="#previous-month" role="tab" aria-controls="pills-setting" aria-selected="false">Setting</a>
                            </li> */}
                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane fade show active" id="current-month" role="tabpanel" aria-labelledby="pills-timeline-tab">
                                <div className="card-body">
                                    <div className="d-flex justify-content-center mb-2 row">
                                        <div className="form-group align-items-center mb-2 col-xl col-md-3 col-12">
                                            <select
                                                className="form-control"
                                                value={carrierFilter}
                                                onChange={e => setCarrierFilter(e.target.value)}
                                            >
                                                <option value="">Tutti gli operatori</option>
                                                {carriers.map(carrier => (
                                                    <option key={carrier.node.id} value={carrier.node.code}>{carrier.node.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="form-group align-items-center mb-2 col-xl col-md-3 col-12">
                                            <select
                                                className="form-control"
                                                value={typeFilter}
                                                onChange={e => setTypeFilter(e.target.value)}
                                            >
                                                <option value="">Tutti i tipi</option>
                                                {targetTypes.map((type, index) => (
                                                    <option key={index} value={type.node.name}>{type.node.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="form-group align-items-center mb-2 col-xl col-md-3 col-12">
                                            <select
                                                className="form-control"
                                                value={userFilter}
                                                onChange={e => setUserFilter(e.target.value)}
                                            >
                                                {userDetails && userDetails.role <= 4 ? (
                                                    <>
                                                        <option value="">Tutti gli utenti</option>
                                                        {/* <option key={user} value={user.toUpperCase()}>{user.toUpperCase()}</option> */}
                                                    </>

                                                ) : null}

                                                {userDetails && userDetails.role <= 4 && users ? users.map((userl, index) => {
                                                    userl = userl.node;
                                                    return (
                                                        <option key={userl.username} value={userl.username}>{userl.username}</option>
                                                    )
                                                }) : (
                                                    <option key={user} value={user.toUpperCase()}>{user.toUpperCase()}</option>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group align-items-center mb-2 col-xl col-md-3 col-12">
                                            <select
                                                className="form-control"
                                                value={sortOrder}
                                                onChange={e => setSortOrder(e.target.value)}
                                            >
                                                <option value="asc">Ordine A-Z</option>
                                                <option value="desc">Ordine Z-A</option>
                                                <option value="date-desc">Più recenti</option>
                                                <option value="date-asc">Più vecchi</option>
                                            </select>
                                        </div>

                                        <div className="btn-group align-items-center mb-2 col-xl col-md-3 col-12">
                                            <button
                                                type="button"
                                                className="btn btn-secondary py-1"
                                                title='Reset filtri'
                                                onClick={() => {
                                                    clearSearch();
                                                    setDateStart("");
                                                    setDateEnd("");
                                                    setTypeFilter("");
                                                    setCarrierFilter("");
                                                    setUserFilter("");
                                                    setSortOrder("date-desc");
                                                }}
                                            >
                                                <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                                                    replay
                                                </span>
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-primary ml-2 py-1"
                                                title="Ricarica timeline"
                                                onClick={() => loadAllTargetItems()}
                                            >
                                                <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                                                    refresh
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-end mb-3">
                                        <label className="account-filter-toggle mb-0" htmlFor="account-only-filtered-data">
                                            <span className="mr-2">Mostra solo i dati corrispondenti ai filtri</span>
                                            <input
                                                id="account-only-filtered-data"
                                                className="account-filter-toggle__input"
                                                type="checkbox"
                                                role="switch"
                                                checked={showOnlyFilteredData}
                                                onChange={e => setShowOnlyFilteredData(e.target.checked)}
                                            />
                                            <span className="account-filter-toggle__track" aria-hidden="true" />
                                        </label>
                                    </div>
                                    <div className="profiletimeline mt-0">
                                        {loadError && (
                                            <div className="alert alert-warning" role="alert">
                                                {loadError}
                                            </div>
                                        )}
                                        {loading ? (
                                            <div className="text-center my-4">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            </div>
                                        ) : (
                                            targetItems ?
                                                targetItems
                                                    .slice()
                                                    .sort((a, b) => {
                                                        if (sortOrder === "date-asc" || sortOrder === "date-desc") {
                                                            const dateA = a[0].node.date ? new Date(a[0].node.date) : new Date(0);
                                                            const dateB = b[0].node.date ? new Date(b[0].node.date) : new Date(0);
                                                            return sortOrder === "date-asc"
                                                                ? dateA - dateB
                                                                : dateB - dateA;
                                                        } else {
                                                            const contactA = a[0].node.Contact[0];
                                                            const contactB = b[0].node.Contact[0];
                                                            const nameA = (contactA.lastName + " " + contactA.firstName).toUpperCase();
                                                            const nameB = (contactB.lastName + " " + contactB.firstName).toUpperCase();
                                                            return sortOrder === "asc"
                                                                ? nameA.localeCompare(nameB, "it", { sensitivity: "base" })
                                                                : nameB.localeCompare(nameA, "it", { sensitivity: "base" });
                                                        }
                                                    })
                                                    .filter(groupedItem => {
                                                        if (showOnlyFilteredData) {
                                                            return groupedItem.some(matchesSelectedFilters);
                                                        }
                                                        // Filtro operatore
                                                        if (carrierFilter && !groupedItem.some(target =>
                                                            target.node.Target[0].name.startsWith(carrierFilter)
                                                        )) {
                                                            return false;
                                                        }
                                                        // Filtro utente
                                                        if (userFilter && !groupedItem.some(target =>
                                                            target.node.User[0].username.startsWith(userFilter)
                                                        )) {
                                                            return false;
                                                        }
                                                        // Filtro tipologia
                                                        if (typeFilter && !groupedItem.some(target =>
                                                            target.node.Target[0].TargetType[0].name.startsWith(typeFilter)
                                                        )) {
                                                            return false;
                                                        }
                                                        // Filtro intervallo date
                                                        if ((dateStart || dateEnd) && !groupedItem.some(target => {
                                                            const d = target.node.date ? target.node.date.slice(0, 10) : "";
                                                            if (dateStart && d < dateStart) return false;
                                                            if (dateEnd && d > dateEnd) return false;
                                                            return true;
                                                        })) {
                                                            return false;
                                                        }
                                                        // Filtro ricerca
                                                        if (searchTerm) {
                                                            const contact = groupedItem[0].node.Contact[0];
                                                            const term = searchTerm.toLowerCase();
                                                            const fullName = `${contact.lastName} ${contact.firstName}`.toLowerCase();
                                                            const rewardsCode = groupedItem[0].node.Target[0].name.toLowerCase();
                                                            // const phone = contact.phone ? contact.phone : "";
                                                            if (
                                                                !fullName.includes(term) &&
                                                                !rewardsCode.includes(term)
                                                                // !phone.includes(term)
                                                            ) {
                                                                return false;
                                                            }
                                                        }
                                                        return true;
                                                    })
                                                    .map(groupedItem => showOnlyFilteredData
                                                        ? groupedItem.filter(matchesSelectedFilters)
                                                        : groupedItem)
                                                    .map((groupedItem, index) => {
                                                        const thisContact = groupedItem[0].node.Contact[0];
                                                        totalItems = index + 1;
                                                        return (
                                                            <React.Fragment key={index}>
                                                                <div className="sl-item">
                                                                    {/* <a href="#" data-toggle="modal" data-target="#exampleModal" onClick={() => setSelectedContact(thisContact)}>
                                                                        <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                                                                            chat_bubble
                                                                        </span>
                                                                    </a>&nbsp; */}
                                                                    <a href="#modal-contact-history" data-toggle="modal" onClick={() => setSelectedContact(thisContact)}>
                                                                        <div className="sl-left bg-white"> <b className="link">{groupedItem ? thisContact.lastName.toUpperCase() + " " + thisContact.firstName.toUpperCase() : ""}</b> <br />{thisContact ? thisContact.fiscalCode?.toUpperCase() : ""}</div>
                                                                    </a>
                                                                    <br />
                                                                </div>
                                                                <div className="sl-item row" key={index}>
                                                                    {groupedItem.map((target, index) => (
                                                                        target = target.node,
                                                                        <React.Fragment key={index}>
                                                                            <div className='col-xl-2 col-lg-3 col-6' tgtid={target.id}>
                                                                                <div className="sl-left"> <img className="rounded-circle" width={150} src={globals.CARRIER_LOGO[target.Target[0].name.substr(0, 3)] ? "https://x1.dixxip.com/dixcore/public/var/assets" + globals.CARRIER_LOGO[target.Target[0].name.substr(0, 3)] : "https://x1.dixxip.com/dixcore/public/var/assets" + globals.CARRIER_LOGO[target.Target[0].name.substr(0, 2)]} alt="" /></div>
                                                                                <div className="sl-right" style={{ marginLeft: "-15px" }}>
                                                                                    <div>
                                                                                        <span className="sl-date">{target.date ? new Date(target.date).toLocaleDateString("it-IT") : ""}</span>
                                                                                        <p className='small'>
                                                                                            <input type="hidden" id={`evaluation-${target.id}`} defaultValue={target.evaluation} onChange={() => { }} />
                                                                                            <b>{target.Target[0].name}</b><br /> ({target.User[0].username}-{target.User_coop ? target.User_coop[0].username : ""})<br />
                                                                                            {target.evaluation ? (
                                                                                                <a href="#modal-quality-call" data-toggle="modal" onClick={() => handleOpenQualityModal(target)}>
                                                                                                    {Array.from({ length: 5 }).map((_, i) => (
                                                                                                        <i
                                                                                                            key={i}
                                                                                                            className={i < target.evaluation ? 'ik ik-star-on text-yellow' : 'ik ik-star-on text-secondary'}
                                                                                                        ></i>
                                                                                                    ))}
                                                                                                </a>
                                                                                            ) : (
                                                                                                <a href="#modal-quality-call" data-toggle="modal" onClick={() => handleOpenQualityModal(target)}>
                                                                                                    <i className='ik ik-star-on text-secondary'></i>
                                                                                                    <i className='ik ik-star-on text-secondary'></i>
                                                                                                    <i className='ik ik-star-on text-secondary'></i>
                                                                                                    <i className='ik ik-star-on text-secondary'></i>
                                                                                                    <i className='ik ik-star-on text-secondary'></i>
                                                                                                </a>
                                                                                            )}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </React.Fragment>
                                                                    ))
                                                                    }
                                                                </div>
                                                                <hr />
                                                            </React.Fragment>
                                                        )
                                                    }) : ""
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Modal per invio messaggio Whatsapp */}
                            {/* <div className="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">Invia messaggio su Whatsapp</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <textarea className="form-control" rows={5} placeholder="Inserisci il tuo messaggio qui..." value={marketingMessage} onChange={e => setMarketingMessage(e.target.value)}></textarea>
                                            <select className="form-control mt-3" value={selectedTemplate} onChange={e => setSelectedTemplate(e.target.value)}>
                                                <option value="">Scegli un template...</option>
                                                {templates.map((template, index) => (
                                                    <option key={index} value={template.node.id}>{template.node.name}</option>
                                                ))}
                                            </select>
                                            <select className="form-control mt-3" onChange={e => setSelectedUser(e.target.value)}>
                                                <option value="">Scegli un utente</option>
                                                {users.map((user, index) => (
                                                    <option key={index} value={user.node.id}>{user.node.username}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                            <a href={selectedContact ? "https://wa.me/39" + selectedContact.phone + "?text=" + encodeURIComponent(marketingMessage) : ""} target='_blank'>
                                                <button type="button" className="btn btn-primary">Invia</button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            {/* <!-- Modal contact history --> */}
                            <div className="modal fade" id="modal-contact-history" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">{selectedContact ? `${selectedContact.lastName.toUpperCase()} ${selectedContact.firstName.toUpperCase()}` : ""}
                                                <br /><small className="text-muted">{selectedContact ? selectedContact.fiscalCode?.toUpperCase() : ""} - {selectedContact ? selectedContact.phone : ""}</small>
                                            </h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>

                                        </div>
                                        <div className="modal-body">
                                            <form className="row" method="post" onSubmit={handleSubmit}>
                                                <input type="hidden" name="Contact" value={selectedContact ? selectedContact.id : ""} />
                                                <div className="form-group col-6">
                                                    <label htmlFor="event-date">Data ricontatto</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        id="event-date"
                                                        name="date"
                                                        value={formDate}
                                                        onChange={e => setFormDate(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                                <div className="form-group col-6">
                                                    <label htmlFor="event-ratio">Probabilità di successo</label>
                                                    <select
                                                        className="form-control"
                                                        id="event-ratio"
                                                        name="outcome"
                                                        value={formRatio}
                                                        onChange={e => setFormRatio(e.target.value)}
                                                        required
                                                    >
                                                        <option value=""></option>
                                                        <option value="4">Certa</option>
                                                        <option value="3">Alta</option>
                                                        <option value="2">Media</option>
                                                        <option value="1">Bassa</option>
                                                        <option value="0">Nulla</option>
                                                    </select>
                                                </div>
                                                <div className="form-group col-6">
                                                    <select className="form-control" onChange={e => setSelectedUser(e.target.value)} name="User" required>
                                                        <option value="">Scegli un utente</option>
                                                        {users.map((user, index) => (
                                                            <option key={index} value={user.node.id}>{user.node.username}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group col-lg-6 col-12">
                                                    <div className='row text-center justify-content-center'>
                                                        <a href='#' onClick={() => setFormRatio("0")} className='col-2 bg-dark p-0'>
                                                            <span className='text-white font-weight-bold'>NULLA</span>
                                                        </a>
                                                        <a href='#' onClick={() => setFormRatio("1")} className='col-2 bg-danger p-0'>
                                                            <span className='text-white font-weight-bold'>BASSA</span>
                                                        </a>
                                                        <a href='#' onClick={() => setFormRatio("2")} className='col-2 bg-warning p-0'>
                                                            <span className='text-white font-weight-bold'>MEDIA</span>
                                                        </a>
                                                        <a href='#' onClick={() => setFormRatio("3")} className='col-2 bg-success p-0'>
                                                            <span className='text-white font-weight-bold'>ALTA</span>
                                                        </a>
                                                        <a href='#' onClick={() => setFormRatio("4")} className='col-2 bg-primary p-0'>
                                                            <span className='text-white font-weight-bold'>CERTA</span>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="form-group col-12">
                                                    <label htmlFor="event-notes">Note/Messaggio</label>
                                                    <textarea
                                                        className="form-control"
                                                        id="event-notes"
                                                        name="note"
                                                        rows={5}
                                                        value={formNotes}
                                                        onChange={e => setFormNotes(e.target.value)}
                                                        placeholder="Aggiungi una nota dettagliata o il testo del messaggio da inviare..."
                                                        required
                                                    />
                                                </div>
                                                <div className="form-group col-6">
                                                    <a href={selectedContact ? "tel:+39" + selectedContact.phone : ""} onClick={() => {
                                                        showInfoToast("Procedi su Collegamento telefono!");
                                                    }}>
                                                        <button type="button" className="btn btn-secondary btn-block col">Chiama</button>
                                                    </a>
                                                </div>
                                                <div className="form-group col-6">
                                                    <a href={selectedContact ? "whatsapp://send?phone=39" + selectedContact.phone + "&text=" + encodeURIComponent(formNotes) : ""} target="_blank" onClick={() => {
                                                        showInfoToast("Procedi su WhatsApp!");
                                                    }}>
                                                        <button type="button" className="btn btn-secondary btn-block col">Invia messaggio</button>
                                                    </a>
                                                </div>
                                                <div className="form-group col-12">
                                                    <button type="submit" className="btn btn-primary btn-block col">Conferma ricontatto</button>
                                                </div>
                                            </form>
                                            <div className="d-flex flex-column gap-2" style={{ maxHeight: "300px", overflowY: "auto", paddingTop: "10px" }}>
                                                {/* Sostituisci events con il tuo array di eventi */}
                                                {selectedContact && contactHistory && contactHistory.length > 0 ? (
                                                    contactHistory.map((event, idx) => (
                                                        event = event.node,
                                                        <div key={idx} className="card mb-2 shadow-sm" style={{
                                                            borderLeft: `5px solid ${event.outcome === 0 ? "#222" :
                                                                event.outcome === 1 ? "#dc3545" :
                                                                    event.outcome === 2 ? "#fd7e14" :
                                                                        event.outcome === 3 ? "#28a745" :
                                                                            event.outcome === 4 ? "#007bff" :
                                                                                "#ccc"
                                                                }`
                                                        }}>
                                                            <div className="card-body p-2">
                                                                <div className="d-flex justify-content-between align-items-center mb-1">
                                                                    <div>
                                                                        <strong className="mr-2">{event.date ? new Date(event.date).toLocaleDateString("it-IT") : ""}</strong>
                                                                        <br />
                                                                        <i>{event.note}</i>
                                                                    </div>
                                                                    <span className="text-muted" style={{ fontSize: 13 }}>
                                                                        {event.User ? event.User[0].username : "Utente sconosciuto"}
                                                                    </span>
                                                                </div>
                                                                <div>
                                                                    <span className="d-block">{event.description}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="text-center text-muted py-4">Nessun ricontatto effettuato.</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Modal quality call --> */}
                            <div className="modal fade" id="modal-quality-call" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">{selectedTargetItem ? `${selectedTargetItem.Target[0].name}` : ""}</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <form className="row" method="post" onSubmit={handleSubmitQuality}>
                                                <div className="form-group col-6">
                                                    <label>Data attivazione</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={selectedTargetItem ? selectedTargetItem.date.substr(0, 10) : ""}
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <label>Venduto</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={selectedTargetItem ? selectedTargetItem.User[0].username : ""}
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <label>Inserito</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={selectedTargetItem ? selectedTargetItem.User_coop?.[0]?.username : ""}
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="form-group col-6">
                                                    <label>Cognome</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={selectedTargetItem ? selectedTargetItem.Contact[0].lastName.capitalize() : ""}
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="form-group col-6">
                                                    <label>Nome</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={selectedTargetItem ? selectedTargetItem.Contact[0].firstName.capitalize() : ""}
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="form-group col-6">
                                                    <label>Codice fiscale/P.IVA</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={selectedTargetItem ? selectedTargetItem.Contact[0].fiscalCode.toUpperCase() || "" : ""}
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="form-group col-6">
                                                    <label>Ragione Sociale</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={selectedTargetItem ? selectedTargetItem.Contact[0].companyName || "" : ""}
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="form-group col-6 text-center">
                                                    <label className='mb-4'>Valutazione generica</label>
                                                    <div className='row text-center justify-content-center'>
                                                        <a onClick={() => setQualityEvaluation("1")} className='col-lg-1 col-2 p-0'>
                                                            <h3><i className={`ik ik-star-on ${qualityEvaluation < 1 ? "text-secondary" : "text-yellow"} `}></i></h3>
                                                        </a>
                                                        <a onClick={() => setQualityEvaluation("2")} className='col-lg-1 col-2 p-0'>
                                                            <h3><i className={`ik ik-star-on ${qualityEvaluation < 2 ? "text-secondary" : "text-yellow"} `}></i></h3>
                                                        </a>
                                                        <a onClick={() => setQualityEvaluation("3")} className='col-lg-1 col-2 p-0'>
                                                            <h3><i className={`ik ik-star-on ${qualityEvaluation < 3 ? "text-secondary" : "text-yellow"} `}></i></h3>
                                                        </a>
                                                        <a onClick={() => setQualityEvaluation("4")} className='col-lg-1 col-2 p-0'>
                                                            <h3><i className={`ik ik-star-on ${qualityEvaluation < 4 ? "text-secondary" : "text-yellow"} `}></i></h3>
                                                        </a>
                                                        <a onClick={() => setQualityEvaluation("5")} className='col-lg-1 col-2 p-0'>
                                                            <h3><i className={`ik ik-star-on ${qualityEvaluation < 5 ? "text-secondary" : "text-yellow"} `}></i></h3>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="form-group col-6 text-center">
                                                    <label>Recapito telefonico</label>
                                                    <h1><strong>{selectedTargetItem ? selectedTargetItem.Contact[0].phone || "" : ""}</strong></h1>
                                                </div>
                                                <div className="form-group col-12">
                                                    <label htmlFor="event-notes">Ulteriori dettagli</label>
                                                    <textarea
                                                        className="form-control"
                                                        id="event-notes"
                                                        name="feedback"
                                                        rows={3}
                                                        value={qualityFeedback}
                                                        onChange={e => setQualityFeedback(e.target.value)}
                                                        placeholder="Aggiungi un'ulteriore nota su altre impressioni o suggerimenti..."
                                                        required
                                                    />
                                                </div>
                                                {qualityAnswers && qualityAnswers.length > 0 ? (
                                                    <div className="form-group col-12">
                                                        {qualityAnswers.map((answer, index) => (
                                                            <div key={index} className="mb-3">
                                                                <div className='row'>
                                                                    <div className="form-group col-8">
                                                                        <h6><strong>{answer.QualityQuestion[0].question}</strong></h6>
                                                                    </div>
                                                                    <div className="form-group col-4 text-right">
                                                                        {answer.rating ? (
                                                                            <>
                                                                                {Array.from({ length: 5 }).map((_, i) => (
                                                                                    <i
                                                                                        key={i}
                                                                                        className={i < answer.rating ? 'ik ik-star-on text-yellow' : 'ik ik-star-on text-secondary'}
                                                                                    ></i>
                                                                                ))}
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <i className='ik ik-star-on text-secondary'></i>
                                                                                <i className='ik ik-star-on text-secondary'></i>
                                                                                <i className='ik ik-star-on text-secondary'></i>
                                                                                <i className='ik ik-star-on text-secondary'></i>
                                                                                <i className='ik ik-star-on text-secondary'></i>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                    <div className='form-group col-12'>
                                                                        <p>{answer.answer}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <React.Fragment>
                                                        {qualityOpen && qualityOpen.length > 0 && (
                                                            <div className="form-group col-12">
                                                                {qualityOpen.map((question, index) => (
                                                                    <div key={index} className="mb-3">
                                                                        <h6><strong>{question.node.title}</strong></h6>
                                                                        <p>{question.node.open}</p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                        {qualityQuestions && qualityQuestions.length > 0 && (
                                                            <div className="form-group col-12">
                                                                {qualityQuestions.map((question, index) => (
                                                                    <div key={index} className="mb-3">
                                                                        <div className='row'>
                                                                            <div className="form-group col-8">
                                                                                <h6><strong>{question.node.question}</strong></h6>
                                                                            </div>
                                                                            <div className="form-group col-4">
                                                                                <div className='row text-center justify-content-center'>
                                                                                    <a onClick={() => { const newRatings = [...qualityQuestionRatings]; newRatings[index] = "1"; setQualityQuestionRatings(newRatings); }} className='col-2 p-0'>
                                                                                        <h6><i className={`ik ik-star-on ${!qualityQuestionRatings[index] || qualityQuestionRatings[index] < 1 ? "text-secondary" : "text-yellow"} `}></i></h6>
                                                                                    </a>
                                                                                    <a onClick={() => { const newRatings = [...qualityQuestionRatings]; newRatings[index] = "2"; setQualityQuestionRatings(newRatings); }} className='col-2 p-0'>
                                                                                        <h6><i className={`ik ik-star-on ${!qualityQuestionRatings[index] || qualityQuestionRatings[index] < 2 ? "text-secondary" : "text-yellow"} `}></i></h6>
                                                                                    </a>
                                                                                    <a onClick={() => { const newRatings = [...qualityQuestionRatings]; newRatings[index] = "3"; setQualityQuestionRatings(newRatings); }} className='col-2 p-0'>
                                                                                        <h6><i className={`ik ik-star-on ${!qualityQuestionRatings[index] || qualityQuestionRatings[index] < 3 ? "text-secondary" : "text-yellow"} `}></i></h6>
                                                                                    </a>
                                                                                    <a onClick={() => { const newRatings = [...qualityQuestionRatings]; newRatings[index] = "4"; setQualityQuestionRatings(newRatings); }} className='col-2 p-0'>
                                                                                        <h6><i className={`ik ik-star-on ${!qualityQuestionRatings[index] || qualityQuestionRatings[index] < 4 ? "text-secondary" : "text-yellow"} `}></i></h6>
                                                                                    </a>
                                                                                    <a onClick={() => { const newRatings = [...qualityQuestionRatings]; newRatings[index] = "5"; setQualityQuestionRatings(newRatings); }} className='col-2 p-0'>
                                                                                        <h6><i className={`ik ik-star-on ${!qualityQuestionRatings[index] || qualityQuestionRatings[index] < 5 ? "text-secondary" : "text-yellow"} `}></i></h6>
                                                                                    </a>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <p>{question.node.description}</p>
                                                                        <div className="d-flex gap-3">
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="event-notes"
                                                                                name="feedback"
                                                                                rows={3}
                                                                                value={qualityQuestionAnswers[index]}
                                                                                onChange={e => {
                                                                                    const newAnswers = [...qualityQuestionAnswers];
                                                                                    newAnswers[index] = e.target.value;
                                                                                    setQualityQuestionAnswers(newAnswers);
                                                                                }}
                                                                                placeholder=""
                                                                                required
                                                                            />
                                                                        </div>

                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}

                                                        {qualityClose && qualityClose.length > 0 && (
                                                            <div className="form-group col-12">
                                                                {qualityClose.map((question, index) => (
                                                                    <div key={index} className="mb-3">
                                                                        <h6><strong>{question.node.title}</strong></h6>
                                                                        <p>{question.node.close}</p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                        <div className="form-group col-12">
                                                            <button type="submit" className="btn btn-primary btn-block col">Salva quality</button>
                                                        </div>
                                                    </React.Fragment>
                                                )}
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <FooterBar
                footerIcon={"person"}
                footerTitle="Account"
                footerProgress={loadProgress}
                footerCount={totalItems ? `${totalItems} ${totalItems === 1 ? "contatto" : "contatti"}` : null}
                footerPlugin={
                    <Calendar
                        rangeStart={dateStart}
                        rangeEnd={dateEnd}
                        setRangeStart={setDateStart}
                        setRangeEnd={setDateEnd}
                    />
                }
                footerButton={
                    <FooterButton icon="download_for_offline" title="Esporta lista" action={() => showInfoToast("Disponibile nel prossimo aggiornamento")} />
                    // <FooterButton icon="download_for_offline" title="Esporta lista" action={() => generatePDF("ciao")} />
                }
            />
        </div>
    );
};
export default Account;